import { getLoginRoleMap, getUnloginRoleMap } from '../../../utils/userFuncs';
import { DELETE_ROLEMAP, UPDATE_ROLEMAP } from '../../constant';

const roleMap = (state = null, action) => {
  const { type, data, wardId, isLogin } = action;
  switch (type) {
    case UPDATE_ROLEMAP:
      if (isLogin) {
        return getLoginRoleMap(data, wardId);
      } else {
        return getUnloginRoleMap(data, wardId);
      }
    case DELETE_ROLEMAP:
      return null;
    default:
      return state;
  }
};

export { roleMap };
